import { __assign } from "tslib";
import { LayoutGridIcon, LayoutMasonryIcon, LayoutCollageIcon, LayoutThumbnailsIcon, LayoutSlideshowIcon, LayoutPanoramaIcon, LayoutSlidesIcon, LayoutColumnsIcon, GridIconSmall, MasonryIconSmall, CollageIconSmall, ThumbnailsIconSmall, SlideshowIconSmall, PanoramaIconSmall, ColumnsIconSmall, SlidesIconSmall, } from '../icons';
import layoutData from './layout-data-provider';
export var switchLayout = function (layout, store) {
    var galleryLayout = layout.value;
    var _componentData = store.get('componentData');
    var styles = Object.assign({ galleryLayout: galleryLayout }, layoutData[galleryLayout]);
    var componentData = __assign(__assign({}, _componentData), { styles: styles });
    store.set('componentData', componentData);
};
export var getCurrentLayout = function (store, t) {
    var componentData = store.get('componentData');
    var galleryLayout = (componentData &&
        componentData.styles &&
        componentData.styles.galleryLayout) ||
        0;
    return galleryLayoutsDropdown(t).find(function (layout) { return layout.value === galleryLayout; });
};
export var getGalleryLayouts = function (t) {
    return [
        { value: 2, label: t('GalleryPlugin_Layout_Grid'), icon: LayoutGridIcon },
        {
            value: 1,
            label: t('GalleryPlugin_Layout_Masonry'),
            icon: LayoutMasonryIcon,
        },
        {
            value: 0,
            label: t('GalleryPlugin_Layout_Collage'),
            icon: LayoutCollageIcon,
        },
        {
            value: 3,
            label: t('GalleryPlugin_Layout_Thumbnails'),
            icon: LayoutThumbnailsIcon,
        },
        {
            value: 9,
            label: t('GalleryPlugin_Layout_Slideshow'),
            icon: LayoutSlideshowIcon,
        },
        {
            value: 6,
            label: t('GalleryPlugin_Layout_Panorama'),
            icon: LayoutPanoramaIcon,
        },
        {
            value: 7,
            label: t('GalleryPlugin_Layout_Columns'),
            icon: LayoutColumnsIcon,
        },
        {
            value: 4,
            label: t('GalleryPlugin_Layout_Slides'),
            icon: LayoutSlidesIcon,
        },
    ];
};
export var galleryLayoutsDropdown = function (t) {
    return [
        { value: 2, label: t('GalleryPlugin_Layout_Grid'), icon: GridIconSmall },
        {
            value: 1,
            label: t('GalleryPlugin_Layout_Masonry'),
            icon: MasonryIconSmall,
        },
        {
            value: 0,
            label: t('GalleryPlugin_Layout_Collage'),
            icon: CollageIconSmall,
        },
        {
            value: 3,
            label: t('GalleryPlugin_Layout_Thumbnails'),
            icon: ThumbnailsIconSmall,
        },
        {
            value: 9,
            label: t('GalleryPlugin_Layout_Slideshow'),
            icon: SlideshowIconSmall,
        },
        {
            value: 6,
            label: t('GalleryPlugin_Layout_Panorama'),
            icon: PanoramaIconSmall,
        },
        {
            value: 7,
            label: t('GalleryPlugin_Layout_Columns'),
            icon: ColumnsIconSmall,
        },
        {
            value: 4,
            label: t('GalleryPlugin_Layout_Slides'),
            icon: SlidesIconSmall,
        },
    ];
};
//# sourceMappingURL=layout-helper.js.map